export const VALID_PASSWORD = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
export const VALID_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const MAX_FILE_SIZE_LIMIT = 10 * 1024 * 1024;
export const GROUP_ID_URL_PATTERN = /^\/groups\/\d+(?:\/|$)/;
